import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import routes from '@Constants/Routes'
import { trackEvent } from '@Utilities/marketingTags'
import { MOBILE } from '../CustomLanding.styled'
import { colors, stickyBar } from '../content'

/* The mobile artboard's fixed bottom action bar — phones only. */
const StickyBar: React.FC = () => {
	const navigate = useNavigate()

	const handleSignup = () => {
		trackEvent('CTAClick', { cta_text: 'signup', cta_location: 'sticky_bar' })
		navigate(routes.signup)
	}

	const handleLogin = () => {
		trackEvent('CTAClick', { cta_text: 'login', cta_location: 'sticky_bar' })
		navigate(routes.login)
	}

	return (
		<Bar>
			<Primary onClick={handleSignup}>{stickyBar.primary}</Primary>
			<Secondary onClick={handleLogin}>{stickyBar.secondary}</Secondary>
		</Bar>
	)
}

export default StickyBar

const Bar = styled.div`
	display: none;
	${MOBILE} {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 70;
		background: ${colors.paper};
		border-top: 1px solid rgba(22, 58, 132, 0.12);
		box-shadow: 0 -8px 24px rgba(8, 20, 50, 0.08);
		padding: 11px 18px 15px;
		display: flex;
		gap: 10px;
		align-items: center;
	}
`

/* min-width: 0 is load-bearing — a flex item defaults to min-width:auto and
   refuses to shrink below its text, so the two buttons together pushed the
   document wider than the viewport and (in RTL) shifted the whole page. */
const Primary = styled.button`
	flex: 1 1 0;
	min-width: 0;
	background: ${colors.amber};
	color: ${colors.navy};
	font-family: inherit;
	font-weight: 700;
	font-size: 15px;
	padding: 13px 12px;
	border-radius: 999px;
	border: none;
	cursor: pointer;
	text-align: center;
	white-space: nowrap;
`

const Secondary = styled.button`
	flex: 0 1 auto;
	min-width: 0;
	background: transparent;
	border: 1.5px solid rgba(22, 58, 132, 0.28);
	color: ${colors.navy};
	font-family: inherit;
	font-weight: 700;
	font-size: 15px;
	padding: 12px 14px;
	border-radius: 999px;
	cursor: pointer;
	text-align: center;
	white-space: nowrap;
`
